import { ThemeProvider, ScopedCssBaseline, styled } from '@mui/material';
import { GlobalStyle, theme } from './theme/theme';
import { ConfidenceFlag as ConfidenceFlagComponent } from '@workboard/ui-okr';

const StyledCssBaseline = styled(ScopedCssBaseline)({
  background: 'transparent'
});

function ConfidenceFlag(props: {
  confidence?: "High" | "Medium" | "Low" | "No Rating";
  comment?: string;
  commentAuthorFullName?: string;
  commentDate?: string;
  anchorEl?: HTMLElement | null | undefined;
}) {
  return (
    <StyledCssBaseline>
      <ThemeProvider theme={theme}>
        <GlobalStyle />
        {props.comment && <ConfidenceFlagComponent
          confidence={props.confidence}
          comment={props.comment}
          commentAuthorFullName={props.commentAuthorFullName}
          commentDate={props.commentDate}
          width={12}
          anchorEl={props.anchorEl}
        />}
      </ThemeProvider>
    </StyledCssBaseline>
  );
}

export default ConfidenceFlag;
